import { jsx } from 'react/jsx-runtime';
import { createCSSConicGradient } from '../../utilities/createCssConicGradient.js';

function ConicGradientWithStops({
  gradient,
  height,
  width,
  x = 0,
  y = 0
}) {
  const conicGradientValue = createCSSConicGradient(gradient);
  return /*#__PURE__*/jsx("foreignObject", {
    x: x,
    y: y,
    width: width,
    height: height,
    children: /*#__PURE__*/jsx("div", {
      style: {
        width: `${width}px`,
        height: `${height}px`,
        backgroundImage: conicGradientValue
      }
    })
  });
}

export { ConicGradientWithStops };
